<div class="card">
    <div class="card-header cp-list-header">
        <span class="cp-list-title"><i class="fa-solid fa-tag"></i> Tags NFC <span class="badge bg-primary ms-1">{{ collectionSize }}</span></span>
        <button class="btn btn-primary btn-sm" (click)="openModal(addDevice)"><i class="fa-solid fa-circle-plus me-1"></i>Nuevo</button>
    </div>
    <div class="card-body">
        <div class="cp-filter-panel" [formGroup]="form">
            <div class="cp-toolbar">
                <div style="flex: 1 1 240px">
                    <label class="form-label">Instalación</label>
                    <select class="form-select" (change)="filterChange()" formControlName="facility_id">
                        <option [value]="0">Todas</option>
                        <option *ngFor="let item of facilityes" [value]="item?.id">{{ item?.name | uppercase }}</option>
                    </select>
                </div>
            </div>
        </div>

        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage" (pageChange)="search()"></ngb-pagination>
        <div class="table-responsive">
            <table class="table cp-table align-middle">
                <thead>
                    <tr><th>Nombre</th><th>Código</th><th>Instalación</th><th>Ubicación</th><th>Creación</th><th></th></tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items">
                        <td class="fw-bold">
                            {{ item?.tag | uppercase }}
                            <span class="badge bg-danger ms-1" *ngIf="item?.state_id==2">Desactivado</span>
                        </td>
                        <td class="small">{{ item?.code | uppercase }}</td>
                        <td class="small">
                            <ng-container *ngIf="item?.facility_id; else notFacility">
                                {{ item?.facility?.name | uppercase }}
                                <div class="text-muted" *ngIf="item?.facility?.location">{{ item?.facility?.location | uppercase }}</div>
                            </ng-container>
                            <ng-template #notFacility><span class="badge bg-warning text-dark">Sin asignar</span></ng-template>
                        </td>
                        <td><span class="badge bg-secondary">{{ (item?.location || 'Sin ubicación') | uppercase }}</span></td>
                        <td class="small text-nowrap">{{ item?.created_at | date: 'dd-MM-yyyy' }}</td>
                        <td class="text-end text-nowrap">
                            <button type="button" class="btn btn-sm btn-outline-primary me-1" title="Editar" (click)="openEdit(item.id,editDevice)"><i class="fa fa-pencil"></i></button>
                            <button type="button" class="btn btn-sm btn-outline-danger" title="Eliminar" (click)="openDelete(item.id,remove)"><i class="fa-solid fa-trash"></i></button>
                        </td>
                    </tr>
                    <tr *ngIf="!items?.length">
                        <td colspan="6"><div class="cp-empty"><i class="fa-solid fa-tag"></i>No se encontraron tags.</div></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage" (pageChange)="search()"></ngb-pagination>
    </div>
</div>

<ng-template #remove let-c="close" let-d="dismiss">
    <form (submit)="delete()" novalidate [formGroup]="form">
        <div class="modal-header">
            <h4 class="modal-title">Eliminar</h4>
            <button type="button" class="btn-close" aria-label="Cerrar" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <p class="mb-0">¿Seguro que desea eliminar este elemento?</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
            <button type="submit" ngbAutofocus class="btn btn-danger">Eliminar</button>
        </div>
    </form>
</ng-template>

<ng-template #addDevice let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-tags (success)="get()"></app-add-tags>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
    </div>
</ng-template>
<ng-template #editDevice let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-edit-tags [dataId]="idSelected" (success)="get()"></app-edit-tags>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
    </div>
</ng-template>